import { Checkbox, Typography } from '@montugroup/design-system';
// import { PaymentRequestType } from '@montugroup/pms-api-contracts/build/api-pms/consultation/contracts/request-payment.contract';
import { FormControlLabel, Stack } from '@mui/material';

interface ConsultChargeNurseProps {
  isMarkedAsComplimentary?: boolean;
  onChangeIsMarkedAsComplimentary?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ConsultChargeNurse = ({
  isMarkedAsComplimentary = false,
  onChangeIsMarkedAsComplimentary,
}: ConsultChargeNurseProps) => {
  return (
    <Stack direction="column" spacing={4} mt={4} data-testid="consult-charge-nurse">
      <Typography>
        If the doctor consultation should be complimentary, please tick the checkbox. Once you save your changes, this
        will appear in the doctor view of the doctor consultation.
      </Typography>
      <Stack direction="row" alignItems="center" gap={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isMarkedAsComplimentary}
              onChange={onChangeIsMarkedAsComplimentary}
              inputProps={{ 'aria-label': 'Complimentary consultation' }}
            />
          }
          label="Complimentary Consultation"
        />
      </Stack>
    </Stack>
  );
};

export { ConsultChargeNurse };
